import { LinearGradient, type LinearGradientProps } from 'expo-linear-gradient'
import { cssInterop } from 'nativewind'

cssInterop(LinearGradient, { className: 'style' })

export { LinearGradient, type LinearGradientProps }
